<svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M14.3333 7.66667C14.3333 11.3487 11.3487 14.3333 7.66667 14.3333H1V7.66667C1 3.98467 3.98467 1 7.66667 1C11.3487 1 14.3333 3.98467 14.3333 7.66667Z" fill="#E5E5E5"/>
  <path d="M4.33333 5.66666H10.3333M4.33333 8.33333H10.3333M4.33333 11H7.66666" stroke="#0c1020" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
